<template>
  <CustomAlert
    type=""
    icon=""
    borderWidth="4"
    class="mb-5 fs-5 align-items-center d-flex justify-content-center rounded-5"
    :class="group"
  >
    <img
      class="img-fluid"
      width="60"
      src="https://osu-image-assets.s3.us-west-2.amazonaws.com/907801f10f0c8ddcfd683b50e8da69b66920edfced894.png"
      alt="House Cup Trophy"
    />
    <h1 class="mb-0 mx-5 text-center">
      <span class="fw-bold">{{ name }}</span> has won the House Cup
    </h1>
    <img
      class="img-fluid"
      width="60"
      src="https://osu-image-assets.s3.us-west-2.amazonaws.com/907801f10f0c8ddcfd683b50e8da69b66920edfced894.png"
      alt="House Cup Trophy"
    />
  </CustomAlert>
</template>

<script>
export default {
  name: "WinnerAnnouncement",
  props: {
    group: {
      type: String
    },
    name: {
      type: String
    }
  }
};
</script>
